import axios from "axios";
import { OrganizationURL } from "../../../config/UrlEndPoint";

export const URL = `${OrganizationURL}organization`;

// Find Plan Usage Log
export function findPlanBalance(queryParams) {
  return axios.post(`${URL}/plan_balance/find`, queryParams);
}
